import { useMetricDetailsMapContext } from '../../../../context/contexts';
import { useMetricQueries } from '../common/hooks';
import { DataOrError } from '../common/types';
import {
  getKpiSectionResponseFromQueryResults,
  getQueriesForKpiSectionConfig,
} from '../common/utils';
import {
  KpiFactboxTwoMetricVizConfig,
  KpiFactboxTwoMetricVizData,
  KpiFactboxTwoMetricVizExternalProps,
} from './types';

export const useKpiFactboxTwoMetricConfigToData = (
  config: KpiFactboxTwoMetricVizConfig,
  externalProps: KpiFactboxTwoMetricVizExternalProps
): DataOrError<KpiFactboxTwoMetricVizData> => {
  const metricDetailsMap = useMetricDetailsMapContext();
  const { title, subtitle, footer } = config;
  const { locale } = externalProps;
  const leftQueries = getQueriesForKpiSectionConfig(
    config.sections.leftSection
  );
  const rightQueries = getQueriesForKpiSectionConfig(
    config.sections.rightSection
  );
  const { queryResponses } = useMetricQueries({
    queries: [...leftQueries, ...rightQueries],
    timeSliderState: externalProps.timeSliderState,
    segmentationState: externalProps.segmentationState,
    filtersState: externalProps.filtersState,
  });
  const leftQueryResponses = queryResponses.slice(0, leftQueries.length);
  const rightQueryResponses = queryResponses.slice(leftQueries.length);
  const leftKpiSectionValue = getKpiSectionResponseFromQueryResults(
    leftQueryResponses,
    config.sections.leftSection,
    metricDetailsMap,
    locale.selected
  );
  const rightKpiSectionValue = getKpiSectionResponseFromQueryResults(
    rightQueryResponses,
    config.sections.rightSection,
    metricDetailsMap,
    locale.selected
  );
  return {
    data: {
      title: title?.[locale.selected],
      subtitle: subtitle?.[locale.selected],
      footer: footer?.[locale.selected],
      fontSize: config.fontSize,
      dataResponse: {
        firstSectionValue: leftKpiSectionValue,
        secondSectionValue: rightKpiSectionValue,
      },
      metricDetailsMap: metricDetailsMap,
    },
    error: null,
  };
};
